import * as React from 'react';
import { NumberFormatProps, default as ReactNumberFormat } from 'react-number-format';

const NumberFormat = (props?: NumberFormatProps) => {
  return <ReactNumberFormat {...props} thousandSeparator='.' decimalSeparator=',' fixedDecimalScale={true} decimalScale={2} />;
};

export default NumberFormat;
